import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../../components/feature/Navbar';
import { Footer } from '../../components/feature/Footer';
import { Button } from '../../components/base/Button';
import { Card } from '../../components/base/Card';
import { SectionHeader } from '../../components/base/SectionHeader';

export default function HomePage() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    setIsVisible(true);
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % 3);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const heroSlides = [
    {
      title: "Güvenilir İnşaat Çözümleri",
      subtitle: "25 yıllık deneyimimizle hayallerinizi gerçeğe dönüştürüyoruz",
      image: "https://public.readdy.ai/ai/img_res/3262973b56ad01524203c4822194e0c5.jpg"
    },
    {
      title: "Kaliteli Konut Projeleri",
      subtitle: "Modern yaşam alanları ve lüks rezidans kompleksleri",
      image: "https://readdy.ai/api/search-image?query=elegant%20modern%20residential%20building%20complex%20with%20beautiful%20architecture%2C%20luxury%20apartment%20buildings%20with%20contemporary%20design%2C%20premium%20housing%20development%20project%20with%20landscaped%20gardens%2C%20sophisticated%20urban%20living%20spaces%20with%20high-end%20finishes&width=1920&height=1080&seq=2&orientation=landscape"
    },
    {
      title: "Ticari Proje Uzmanlığı",
      subtitle: "İş merkezleri ve ticari yapılarda sektör lideri",
      image: "https://readdy.ai/api/search-image?query=impressive%20modern%20commercial%20building%20with%20glass%20facade%20and%20steel%20structure%2C%20contemporary%20office%20tower%20and%20business%20center%20architecture%2C%20professional%20commercial%20development%20project%20with%20elegant%20design%2C%20sophisticated%20urban%20commercial%20complex&width=1920&height=1080&seq=3&orientation=landscape"
    }
  ];

  const values = [
    {
      icon: 'ri-time-line',
      title: 'Zamanında Teslim',
      description: 'Belirlenen sürelerde projelerinizi eksiksiz tamamlıyoruz',
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: 'ri-award-line',
      title: 'Kalite Standartları',
      description: 'Uluslararası standartlarda kaliteli inşaat hizmeti',
      color: 'from-emerald-500 to-emerald-600'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Güvenilir Süreç',
      description: 'Her aşamada şeffaf ve güvenilir iş süreçleri',
      color: 'from-amber-500 to-amber-600'
    }
  ];

  const statistics = [
    { number: '25+', label: 'Yıllık Deneyim', icon: 'ri-calendar-line' },
    { number: '150+', label: 'Tamamlanan Proje', icon: 'ri-building-line' },
    { number: '500K+', label: 'Toplam İnşaat Alanı (m²)', icon: 'ri-ruler-line' },
    { number: '98%', label: 'Müşteri Memnuniyeti', icon: 'ri-heart-line' }
  ];

  const services = [
    {
      icon: 'ri-home-line',
      title: 'Konut Projeleri',
      description: 'Modern yaşam alanları ve lüks konut kompleksleri',
      features: ['Villa Projeleri', 'Apartman Kompleksleri', 'Rezidans Projeleri'],
      image: 'https://readdy.ai/api/search-image?query=beautiful%20modern%20residential%20villa%20with%20contemporary%20architecture%2C%20luxury%20home%20design%20with%20elegant%20landscaping%2C%20premium%20residential%20construction%20project%20with%20sophisticated%20exterior%20design%2C%20high-end%20housing%20development&width=400&height=300&seq=4&orientation=landscape'
    },
    {
      icon: 'ri-building-2-line',
      title: 'Ticari Projeler',
      description: 'İş merkezleri ve ticari yapılar',
      features: ['Ofis Binaları', 'AVM Projeleri', 'Endüstriyel Yapılar'],
      image: 'https://readdy.ai/api/search-image?query=modern%20commercial%20office%20building%20with%20glass%20facade%2C%20contemporary%20business%20center%20architecture%2C%20professional%20commercial%20development%20with%20sleek%20design%2C%20sophisticated%20urban%20office%20complex&width=400&height=300&seq=5&orientation=landscape'
    },
    {
      icon: 'ri-hammer-line',
      title: 'Tadilat & Renovasyon',
      description: 'Mevcut yapıların yenilenmesi ve modernizasyonu',
      features: ['İç Mekan Tasarımı', 'Cephe Yenileme', 'Sistem Güncellemeleri'],
      image: 'https://readdy.ai/api/search-image?query=elegant%20interior%20renovation%20project%20with%20modern%20design%20elements%2C%20sophisticated%20home%20improvement%20and%20remodeling%20work%2C%20premium%20interior%20construction%20with%20contemporary%20finishes%2C%20luxury%20renovation%20project&width=400&height=300&seq=6&orientation=landscape'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Arsa Geliştirme',
      description: 'Arsa değerlendirme ve proje geliştirme hizmetleri',
      features: ['Fizibilite Analizi', 'Proje Tasarımı', 'İnşaat Yönetimi'],
      image: 'https://readdy.ai/api/search-image?query=professional%20land%20development%20planning%20with%20architectural%20blueprints%2C%20construction%20site%20planning%20and%20development%20project%2C%20urban%20development%20with%20surveying%20equipment%2C%20sophisticated%20land%20development%20project&width=400&height=300&seq=7&orientation=landscape'
    }
  ];

  const featuredProjects = [
    {
      id: 1,
      title: 'Ataşehir Residence',
      location: 'Ataşehir, İstanbul',
      area: '15.000 m²',
      status: 'Devam Eden',
      statusColor: 'bg-blue-500',
      image: 'https://readdy.ai/api/search-image?query=modern%20residential%20building%20construction%20site%20with%20elegant%20architecture%2C%20contemporary%20apartment%20complex%20under%20construction%20with%20premium%20materials%2C%20sophisticated%20urban%20development%20project%20in%20Istanbul%20with%20professional%20construction%20management&width=400&height=300&seq=8&orientation=landscape'
    },
    {
      id: 2,
      title: 'Kadıköy Plaza',
      location: 'Kadıköy, İstanbul',
      area: '8.500 m²',
      status: 'Tamamlanan',
      statusColor: 'bg-green-500',
      image: 'https://readdy.ai/api/search-image?query=completed%20modern%20commercial%20plaza%20building%20with%20elegant%20glass%20facade%2C%20contemporary%20office%20architecture%20with%20sophisticated%20design%2C%20premium%20urban%20commercial%20development%20with%20beautiful%20lighting&width=400&height=300&seq=9&orientation=landscape'
    },
    {
      id: 3,
      title: 'Beşiktaş Towers',
      location: 'Beşiktaş, İstanbul',
      area: '22.000 m²',
      status: 'Gelecek',
      statusColor: 'bg-orange-500',
      image: 'https://readdy.ai/api/search-image?query=future%20modern%20twin%20towers%20architectural%20rendering%20with%20sophisticated%20design%2C%20contemporary%20high-rise%20building%20visualization%2C%20elegant%20urban%20skyline%20development%20project%20with%20premium%20architecture&width=400&height=300&seq=10&orientation=landscape'
    }
  ];

  const testimonials = [
    {
      name: 'Mehmet Yılmaz',
      position: 'Villa Sahibi',
      content: 'Birsöz İnşaat ile çalışmak harika bir deneyimdi. Hayalimizin evini zamanında ve kaliteli bir şekilde teslim ettiler.',
      rating: 5,
      project: 'Zekeriyaköy Villa Projesi',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20man%20portrait%20with%20confident%20smile%2C%20middle-aged%20Turkish%20businessman%20in%20elegant%20suit%2C%20sophisticated%20client%20testimonial%20photo%20with%20clean%20background&width=80&height=80&seq=11&orientation=squarish'
    },
    {
      name: 'Ayşe Demir',
      position: 'İş Merkezi Yatırımcısı',
      content: 'Profesyonel yaklaşımları ve şeffaf süreçleri sayesinde projemiz beklentilerimizi aştı. Kesinlikle tavsiye ederim.',
      rating: 5,
      project: 'Ataşehir Business Center',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20woman%20portrait%20with%20confident%20expression%2C%20elegant%20Turkish%20businesswoman%20in%20professional%20attire%2C%20sophisticated%20client%20testimonial%20photo%20with%20clean%20background&width=80&height=80&seq=12&orientation=squarish'
    },
    {
      name: 'Ali Kaya',
      position: 'Apartman Yöneticisi',
      content: 'Tadilat projemizde gösterdikleri titizlik ve kalite anlayışı gerçekten takdire şayan. Çok memnun kaldık.',
      rating: 5,
      project: 'Kadıköy Apartman Renovasyonu',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20middle-aged%20man%20portrait%20with%20friendly%20smile%2C%20Turkish%20apartment%20manager%20in%20business%20casual%20attire%2C%20sophisticated%20client%20testimonial%20photo%20with%20clean%20background&width=80&height=80&seq=13&orientation=squarish'
    }
  ];

  return (
    <div className="min-h-screen bg-white overflow-hidden">
      <Navbar />
      
      {/* Hero Section with Slider */}
      <section className="relative min-h-screen flex items-center justify-center">
        {heroSlides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
            style={{
              backgroundImage: `linear-gradient(rgba(14, 56, 81, 0.75), rgba(14, 56, 81, 0.75)), url('${slide.image}')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }}
          >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white h-full flex items-center">
              <div className={`max-w-4xl mx-auto transform transition-all duration-1000 ${
                isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
              }`}>
                <h1 className="text-[32px] md:text-[42px] font-bold mb-6 leading-tight">
                  {slide.title}
                </h1>
                <p className="text-[18px] md:text-[20px] mb-8 text-gray-200 max-w-2xl mx-auto">
                  {slide.subtitle}
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Link to="/projeler">
                    <Button size="lg" className="w-full sm:w-auto transform hover:scale-105 transition-all duration-300">
                      <i className="ri-building-line mr-2"></i>
                      Projeleri Keşfedin
                    </Button>
                  </Link>
                  <Link to="/arsa-degerlendirme">
                    <Button variant="outline" size="lg" className="w-full sm:w-auto bg-white/10 border-white text-white hover:bg-white hover:text-[#0e3851] transform hover:scale-105 transition-all duration-300">
                      <i className="ri-map-line mr-2"></i>
                      Ücretsiz Değerlendirme
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
        
        {/* Slider Indicators */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2">
          {heroSlides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                index === currentSlide ? 'bg-white' : 'bg-white/50'
              }`}
            />
          ))}
        </div>
      </section>

      {/* Floating Statistics */}
      <section className="relative -mt-20 z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-3xl shadow-2xl p-8">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              {statistics.map((stat, index) => (
                <div 
                  key={index} 
                  className={`text-center transform transition-all duration-500 hover:scale-105 ${
                    isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
                  }`}
                  style={{ transitionDelay: `${index * 100}ms` }}
                >
                  <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-[#0e3851] to-[#1a5a7a] rounded-2xl mx-auto mb-4 shadow-lg">
                    <i className={`${stat.icon} text-[24px] text-white`}></i>
                  </div>
                  <div className="text-[28px] font-bold mb-2 text-[#0e3851]">{stat.number}</div>
                  <div className="text-[14px] text-gray-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeader 
            title="Neden Birsöz İnşaat?"
            subtitle="Sektördeki deneyimimiz ve kalite anlayışımızla fark yaratıyoruz"
            centered
            className="mb-16"
          />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {values.map((value, index) => (
              <Card 
                key={index} 
                className={`text-center group hover:shadow-2xl transform transition-all duration-500 hover:-translate-y-2 ${
                  isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
                }`}
                style={{ transitionDelay: `${index * 200}ms` }}
              >
                <div className={`w-20 h-20 flex items-center justify-center bg-gradient-to-br ${value.color} rounded-2xl mx-auto mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${value.icon} text-[28px] text-white`}></i>
                </div>
                <h3 className="text-[20px] font-semibold text-[#0e3851] mb-3">{value.title}</h3>
                <p className="text-[15px] text-gray-600 leading-relaxed">{value.description}</p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeader 
            title="Hizmetlerimiz"
            subtitle="Konuttan ticariye, tadilattan yeni inşaata kadar geniş hizmet yelpazesi"
            centered
            className="mb-16"
          />
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {services.map((service, index) => (
              <Card 
                key={index} 
                className={`group hover:shadow-2xl transform transition-all duration-500 hover:-translate-y-1 overflow-hidden ${
                  isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
                }`}
                style={{ transitionDelay: `${index * 150}ms` }}
              >
                <div className="relative overflow-hidden rounded-xl mb-6">
                  <img 
                    src={service.image}
                    alt={service.title}
                    className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0e3851]/20 to-transparent"></div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#0e3851]/10 rounded-xl flex-shrink-0">
                    <i className={`${service.icon} text-[20px] text-[#0e3851]`}></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-[20px] font-semibold text-[#0e3851] mb-2">{service.title}</h3>
                    <p className="text-[15px] text-gray-600 mb-4 leading-relaxed">{service.description}</p>
                    <ul className="space-y-2">
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="text-[14px] text-gray-500 flex items-center">
                          <i className="ri-check-line text-[#0e3851] mr-2"></i>
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Projects - COMPLETELY REDESIGNED */}
      <section className="py-32 bg-[#0e3851] relative overflow-hidden">
        {/* Animated Background Elements */}
        <div className="absolute inset-0">
          <div className="absolute top-20 left-10 w-72 h-72 bg-[#1a5a7a]/20 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#2a6a8a]/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }}></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#1a5a7a]/10 rounded-full blur-3xl animate-spin" style={{ animationDuration: '20s' }}></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          {/* Section Header with Advanced Styling */}
          <div className="text-center mb-20">
            <div className="inline-flex items-center px-6 py-3 bg-white/10 rounded-full border border-white/20 backdrop-blur-sm mb-6">
              <i className="ri-building-4-line text-white mr-2"></i>
              <span className="text-white text-sm font-medium">Premium Projeler</span>
            </div>
            <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Öne Çıkan
              <br />
              <span className="text-[#87ceeb]">Projelerimiz</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
              Kaliteli inşaat anlayışımızla hayata geçirdiğimiz projeler, modern mimarinin en güzel örnekleri
            </p>
          </div>

          {/* Advanced Project Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
            {featuredProjects.map((project, index) => (
              <div 
                key={project.id}
                className={`group relative ${
                  index === 1 ? 'lg:scale-110 lg:-mt-8 lg:mb-8' : ''
                } ${
                  isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
                } transition-all duration-1000`}
                style={{ transitionDelay: `${index * 200}ms` }}
              >
                {/* Main Card */}
                <div className="relative bg-white/10 backdrop-blur-xl rounded-3xl border border-white/20 overflow-hidden group-hover:border-white/40 transition-all duration-500 group-hover:shadow-2xl group-hover:shadow-[#0e3851]/20">
                  {/* Image Container with Advanced Effects */}
                  <div className="relative h-80 overflow-hidden">
                    <img 
                      src={project.image}
                      alt={project.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    />
                    
                    {/* Gradient Overlays */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                    <div className="absolute inset-0 bg-[#0e3851]/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                    
                    {/* Status Badge with Glow Effect */}
                    <div className={`absolute top-6 right-6 px-4 py-2 rounded-full text-white text-sm font-medium backdrop-blur-sm border border-white/20 ${project.statusColor} shadow-lg`}>
                      <div className={`absolute inset-0 ${project.statusColor} rounded-full blur-md opacity-50`}></div>
                      <span className="relative">{project.status}</span>
                    </div>

                    {/* Floating Action Button */}
                    <div className="absolute top-6 left-6 w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full border border-white/30 flex items-center justify-center opacity-0 group-hover:opacity-100 transform scale-0 group-hover:scale-100 transition-all duration-500">
                      <i className="ri-eye-line text-white text-lg"></i>
                    </div>

                    {/* Bottom Info Overlay */}
                    <div className="absolute bottom-0 left-0 right-0 p-6">
                      <h3 className="text-2xl font-bold text-white mb-2 group-hover:text-[#87ceeb] transition-colors duration-300">
                        {project.title}
                      </h3>
                      <div className="flex items-center text-gray-300 mb-4">
                        <i className="ri-map-pin-line mr-2 text-[#87ceeb]"></i>
                        <span className="text-sm">{project.location}</span>
                      </div>
                    </div>
                  </div>

                  {/* Card Content - Enhanced with more info */}
                  <div className="p-6">
                    {/* Project Details */}
                    <div className="grid grid-cols-2 gap-4 mb-6">
                      <div className="flex items-center text-gray-300">
                        <i className="ri-ruler-line mr-2 text-[#87ceeb]"></i>
                        <div>
                          <div className="text-xs text-gray-400">Alan</div>
                          <div className="text-sm font-medium">{project.area}</div>
                        </div>
                      </div>
                      <div className="flex items-center text-gray-300">
                        <i className="ri-calendar-line mr-2 text-[#87ceeb]"></i>
                        <div>
                          <div className="text-xs text-gray-400">Durum</div>
                          <div className="text-sm font-medium">{project.status}</div>
                        </div>
                      </div>
                    </div>

                    {/* Additional Project Info */}
                    <div className="space-y-3 mb-6">
                      <div className="flex items-center justify-between text-sm">
                        <span className="text-gray-400">Kat Sayısı:</span>
                        <span className="text-white font-medium">
                          {project.id === 1 ? '12 Kat' : project.id === 2 ? '8 Kat' : '25 Kat'}
                        </span>
                      </div>
                      <div className="flex items-center justify-between text-sm">
                        <span className="text-gray-400">Daire Sayısı:</span>
                        <span className="text-white font-medium">
                          {project.id === 1 ? '120 Daire' : project.id === 2 ? '45 Ofis' : '200 Daire'}
                        </span>
                      </div>
                      <div className="flex items-center justify-between text-sm">
                        <span className="text-gray-400">Teslim Tarihi:</span>
                        <span className="text-white font-medium">
                          {project.id === 1 ? '2025 Q2' : project.id === 2 ? 'Tamamlandı' : '2027 Q4'}
                        </span>
                      </div>
                      <div className="flex items-center justify-between text-sm">
                        <span className="text-gray-400">Proje Değeri:</span>
                        <span className="text-white font-medium">
                          {project.id === 1 ? '₺85M' : project.id === 2 ? '₺45M' : '₺150M'}
                        </span>
                      </div>
                    </div>

                    {/* Progress Bar for ongoing projects */}
                    {project.status === 'Devam Eden' && (
                      <div className="mb-6">
                        <div className="flex items-center justify-between text-sm mb-2">
                          <span className="text-gray-400">İlerleme</span>
                          <span className="text-white font-medium">
                            {project.id === 1 ? '65%' : '45%'}
                          </span>
                        </div>
                        <div className="w-full bg-white/10 rounded-full h-2">
                          <div 
                            className="bg-[#87ceeb] h-2 rounded-full transition-all duration-1000"
                            style={{ width: project.id === 1 ? '65%' : '45%' }}
                          ></div>
                        </div>
                      </div>
                    )}

                    {/* Action Button */}
                    <Link to={`/projeler/${project.id}`}>
                      <button className="w-full py-4 bg-[#0e3851] text-white font-semibold rounded-2xl hover:bg-[#1a5a7a] transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl border border-white/20">
                        <span className="flex items-center justify-center">
                          Detayları Keşfet
                          <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform duration-300"></i>
                        </span>
                      </button>
                    </Link>
                  </div>

                  {/* Decorative Elements */}
                  <div className="absolute -top-2 -right-2 w-20 h-20 bg-[#87ceeb]/20 rounded-full blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  <div className="absolute -bottom-2 -left-2 w-16 h-16 bg-[#87ceeb]/20 rounded-full blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                </div>

                {/* Floating Number Badge */}
                <div className={`absolute -top-4 -left-4 w-12 h-12 bg-[#0e3851] rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg border-2 border-white/20 ${
                  index === 1 ? 'bg-[#87ceeb] text-[#0e3851]' : ''
                }`}>
                  {index + 1}
                </div>
              </div>
            ))}
          </div>

          {/* Advanced CTA Section */}
          <div className="text-center">
            <div className="inline-flex flex-col sm:flex-row gap-4">
              <Link to="/projeler">
                <button className="px-8 py-4 bg-[#87ceeb] text-[#0e3851] font-semibold rounded-2xl hover:bg-white transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl group">
                  <span className="flex items-center">
                    <i className="ri-building-line mr-2"></i>
                    Tüm Projeleri Keşfet
                    <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform duration-300"></i>
                  </span>
                </button>
              </Link>
              <Link to="/arsa-degerlendirme">
                <button className="px-8 py-4 bg-white/10 backdrop-blur-sm border border-white/20 text-white font-semibold rounded-2xl hover:bg-white/20 transform hover:scale-105 transition-all duration-300 group">
                  <span className="flex items-center">
                    <i className="ri-calculator-line mr-2"></i>
                    Ücretsiz Değerlendirme
                    <i className="ri-external-link-line ml-2 group-hover:translate-x-1 transition-transform duration-300"></i>
                  </span>
                </button>
              </Link>
            </div>
          </div>

          {/* Floating Stats Cards */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-20">
            {[
              { icon: 'ri-award-line', value: '25+', label: 'Ödül', color: 'bg-[#87ceeb]' },
              { icon: 'ri-team-line', value: '50+', label: 'Uzman Ekip', color: 'bg-[#0e3851]' },
              { icon: 'ri-time-line', value: '100%', label: 'Zamanında', color: 'bg-[#87ceeb]' },
              { icon: 'ri-heart-line', value: '98%', label: 'Memnuniyet', color: 'bg-[#0e3851]' }
            ].map((stat, index) => (
              <div 
                key={index}
                className={`bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 text-center group hover:bg-white/10 transition-all duration-300 ${
                  isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
                }`}
                style={{ transitionDelay: `${1000 + index * 100}ms` }}
              >
                <div className={`w-12 h-12 ${stat.color} rounded-xl flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${stat.icon} text-white text-lg`}></i>
                </div>
                <div className="text-2xl font-bold text-white mb-1">{stat.value}</div>
                <div className="text-sm text-gray-400">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeader 
            title="Müşterilerimiz Ne Diyor?"
            subtitle="Projelerimizi tamamlayan müşterilerimizin deneyimleri"
            centered
            className="mb-16"
          />
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <Card 
                key={index} 
                className={`group hover:shadow-2xl transform transition-all duration-500 hover:-translate-y-2 ${
                  isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
                }`}
                style={{ transitionDelay: `${index * 150}ms` }}
              >
                <div className="flex items-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-[16px]"></i>
                  ))}
                </div>
                <p className="text-[15px] text-gray-600 mb-6 italic leading-relaxed">"{testimonial.content}"</p>
                <div className="flex items-center space-x-4 border-t pt-4">
                  <img 
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full object-cover"
                  />
                  <div>
                    <div className="font-semibold text-[#0e3851] text-[16px]">{testimonial.name}</div>
                    <div className="text-[14px] text-gray-500">{testimonial.position}</div>
                    <div className="text-[12px] text-gray-400 mt-1">{testimonial.project}</div>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Banner */}
      <section 
        className="py-20 relative"
        style={{
          backgroundImage: `linear-gradient(rgba(14, 56, 81, 0.9), rgba(14, 56, 81, 0.9)), url('https://readdy.ai/api/search-image?query=elegant%20construction%20consultation%20meeting%20with%20architectural%20plans%2C%20professional%20business%20meeting%20in%20modern%20office%20with%20construction%20blueprints%2C%20sophisticated%20client%20consultation%20with%20premium%20interior%20design&width=1920&height=600&seq=14&orientation=landscape')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h2 className="text-[28px] md:text-[32px] font-bold mb-4">
            Hayalinizdeki Projeyi Birlikte Gerçekleştirelim
          </h2>
          <p className="text-[18px] text-gray-200 mb-8 max-w-2xl mx-auto">
            25 yıllık deneyimimiz ve uzman ekibimizle size en uygun çözümü sunmaya hazırız. 
            Ücretsiz keşif ve danışmanlık hizmeti için bizimle iletişime geçin.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/arsa-degerlendirme">
              <Button size="lg" className="w-full sm:w-auto bg-white text-[#0e3851] hover:bg-gray-100 transform hover:scale-105 transition-all duration-300">
                <i className="ri-calculator-line mr-2"></i>
                Ücretsiz Değerlendirme
              </Button>
            </Link>
            <Link to="/iletisim">
              <Button variant="outline" size="lg" className="w-full sm:w-auto border-white text-white hover:bg-white hover:text-[#0e3851] transform hover:scale-105 transition-all duration-300">
                <i className="ri-phone-line mr-2"></i>
                Hemen Arayın
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}